// import { ResponseType } from 'axios';
import { CommonResponse } from '@auth_module/services';
import { queryIntegrationsApi, queryIntegrationsRefreshableApi } from '@configs/axios-instances';
import {
  IIntegrationTag,
  IntegrationRequestType,
  CreateTagParamsType,
  UpdateTagDesriptionParamsType,
} from '@insights_module/types/Integrations';

/**
 * Get Integration tags
 * @param {IntegrationRequestType} type
 * @return {Promise<CommonResponse>}
 */
export const getIntegrationTags = async ({
  type,
  token,
  page_size,
  name,
}: {
  type: IntegrationRequestType;
  token?: string;
  page_size?: number;
  name?: string;
}): Promise<any> => {
  return await queryIntegrationsApi.get(`/query/integrations/${type}`, {
    params: { token, page_size, name },
  });
};

export const createIntegrationTag = async (params: CreateTagParamsType) => {
  return await queryIntegrationsRefreshableApi.post('/query', params);
};

/**
 * Update Integration tag
 * @param {string} id
 * @param {UpdateTagDesriptionParamsType} payload
 * @return {Promise<CommonResponse>}
 */

export const updateIntegrationTagDescription = async (
  id: string,
  payload: UpdateTagDesriptionParamsType
): Promise<CommonResponse> => {
  return await queryIntegrationsRefreshableApi.put(`/query/${id}`, payload);
};

/**
 * Delete Integration tag
 * @param {string} id
 * @return {Promise<CommonResponse>}
 */
export const deleteIntegrationTag = async (id: string): Promise<CommonResponse> => {
  return queryIntegrationsRefreshableApi.delete(`/query/${id}`);
};

/**
 * Get tag version history
 * @param {string} id
 * @return {Promise<IIntegrationTag>}
 */
export const getTagHistory = async (id: string | undefined): Promise<IIntegrationTag> => {
  return await queryIntegrationsRefreshableApi.get(`/query/${id}/version-history`);
};

/**
 * Create tag version
 * @param {string} id
 * @return {Promise<IIntegrationTag>}
 */
export const createTagVersion = async (
  id: string | undefined,
  params: Omit<CreateTagParamsType, 'integrations'>
): Promise<IIntegrationTag> => {
  return await queryIntegrationsRefreshableApi.post(`/query/${id}/version`, params);
};
